import { GEO_LOCATION_TYPES } from "~/entity/Geo/model/shema";
import { FilterField, FilterFieldOption } from "~/features/filter";

type Translate = (key: string) => string;

const typeOptions = (t: Translate): FilterFieldOption[] =>
  GEO_LOCATION_TYPES.map((type) => ({
    label: t(`addressSelectionGuide.typeOptions.${type}`),
    value: type,
  }));

const activeOptions = (t: Translate): FilterFieldOption[] => [
  { label: t("k.yes"), value: "true" },
  { label: t("k.no"), value: "false" },
];

/**
 * Описание полей формы фильтрации справочника адресов.
 * Имена полей соответствуют параметрам GET /geo/places, чтобы
 * их можно было напрямую передавать в API.
 */
export const addressSelectionGuideFilterFields = (
  t: Translate,
): FilterField[] => [
  {
    name: "id",
    type: "input",
    label: t("addressSelectionGuide.id"),
  },
  {
    name: "parentId",
    type: "input",
    label: t("addressSelectionGuide.parentId"),
  },
  {
    name: "name",
    type: "input",
    label: t("addressSelectionGuide.name"),
  },
  {
    name: "type",
    type: "select",
    label: t("addressSelectionGuide.type"),
    options: typeOptions(t),
  },
  {
    name: "socr",
    type: "input",
    label: t("addressSelectionGuide.socr"),
  },
  {
    name: "index",
    type: "input",
    label: t("addressSelectionGuide.index"),
  },
  {
    name: "cladrCode",
    type: "input",
    label: t("addressSelectionGuide.cladrCode"),
  },
  {
    name: "okatoCode",
    type: "input",
    label: t("addressSelectionGuide.okatoCode"),
  },
  {
    name: "fiasId",
    type: "input",
    label: t("addressSelectionGuide.fiasId"),
  },
  {
    name: "fiasValue",
    type: "input",
    label: t("addressSelectionGuide.fiasValue"),
  },
];
